import { render, staticRenderFns } from "./OutrosServicosComponente.vue?vue&type=template&id=4466430a&scoped=true"
import script from "./OutrosServicosComponente.vue?vue&type=script&lang=js"
export * from "./OutrosServicosComponente.vue?vue&type=script&lang=js"
import style0 from "./OutrosServicosComponente.vue?vue&type=style&index=0&id=4466430a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466430a",
  null
  
)

export default component.exports